import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { sentryDns, environment, isProd } from 'configs';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { hotjar } from 'react-hotjar';
import { BrowserRouter as Router } from 'react-router-dom';
import { SocketContext, socket } from 'contexts/SocketContext';
import App from './App';
import './index.css';
// import reportWebVitals from './reportWebVitals';
import configureStore from './redux/configureStore';


if (!sentryDns) {
  console.log('SENTRY is not configured yet');
} else {
  Sentry.init({
    dsn: sentryDns,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment,
  });
}

if (isProd) {
  hotjar.initialize(3229289, 6);
}

const store = configureStore();

ReactDOM.render(
  <SocketContext.Provider value={socket}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </SocketContext.Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
